import React, { Fragment, } from "react";
import { Box, TableContainer, Paper, Table, TableBody, TableCell, TableRow, } from "@mui/material";
import { EnhancedTableHead } from "../../../../components/CustomTable";
const HeadColumn = ({onGetVisitListStart,
    visitScreen: {visitData, page_details}}) => {
    
    const [dense, setDense] = React.useState(false);
    type Order = "asc" | "desc";
    const [order, setOrder] = React.useState<Order>("asc");
    const [orderBy, setOrderBy] = React.useState<any>("name");

    interface HeadCell {
        disablePadding: boolean;
        id: any;
        label: string;
        isShow: boolean;
        numeric: boolean;
        align?: string;
    }
    const headCells: readonly HeadCell[] = [
        {
            id: "name",
            numeric: false,
            disablePadding: true,
            label: "Salesman Name",
            isShow: true,
        },
        {
            id: "total_just_visited",
            numeric: false,
            disablePadding: true,
            label: "Total Visits",
            isShow: true,
        },
    ]
    const handleRequestSort = (field) => {
        const isAsc = orderBy === field && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(field);
        onGetVisitListStart();
    };
    React.useEffect(() => {
        onGetVisitListStart();
    }, []);
    return(
        <Fragment>
            <Box sx = {{ overflow: "auto"}}>
                <Box sx={{ width: "100%", display: "table", tableLayout: "fixed", }}>
                    <TableContainer component={Paper}>
                        <Table aria-labelledby="tableTitle" size={dense ? "small" : "medium"}>
                            <EnhancedTableHead
                              numSelected={0}
                              order={order}
                              orderBy={orderBy}
                              onSelectAllClick={() => {}}
                              onRequestSort={(event, property) => handleRequestSort(property)}
                              rowCount={visitData?.length}
                              headCells={headCells}
                              isCheckBox = {false}
                            />
                            <TableBody>
                                {visitData && visitData.length > 0 ? (
                                    visitData?.map((row, index) => {
                                        return(
                                            <TableRow key={index}>
                                                <TableCell align="center" sx={{
                                                    borderTop: "1px solid #ebeded",
                                                    borderRight: "1px solid #ebeded",
                                                    borderLeft: "1px solid #ebeded", 
                                                    height: "75px",
                                                }}>
                                                  {row?.name ? row?.name : "-"}
                                                </TableCell>
                                                <TableCell align="center" sx={{
                                                    borderTop: "1px solid #ebeded",
                                                    borderRight: "1px solid #ebeded",
                                                    borderLeft: "1px solid #ebeded", 
                                                    height: "75px",
                                                }}>
                                                  {row?.total_just_visited ? (row?.total_just_visited) : (0)}
                                                </TableCell>
                                            </TableRow>)
                                        }) ) :
                                            (
                                                <TableRow>
                                                    <TableCell colSpan={headCells.length} align="center">
                                                        No Data Available
                                                    </TableCell>
                                                </TableRow>
                                            )
                                    }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Box>
        </Fragment>
    )
}

export default HeadColumn;